export default "__VITE_ASSET__4L9PYsZy_HwMKA$zvPd7VQ__"